module.exports = __webpack_public_path__ + "static/media/bingo-ticket-price.4604f65c.png";